<template>
    <div class="mt-2">
        <protokol-floating-settings>
            <div class="p-3">
                <p v-if="app.engine"><strong>Engine</strong>: {{ app.engine }}</p>
                <p v-if="app.app_version"><strong>SDK Version</strong>: {{ app.app_version }}</p>
                <b-form-group label="Port">
                    <b-form-input v-model="port" />
                </b-form-group>
            </div>
        </protokol-floating-settings>
        
        <b-row class="vh-100" align-v="center" v-if="dist === null" >
            <b-col cols="12" md="8" offset-md="2" align-self="center">
                <b-row align-h="center">
                    <b-col cols="12" align-self="center" style="text-align:center" class="mb-5">
                        <b-alert show variant="warning"> {{ $t("tryRunningPlaygroundWithToolkit") }} </b-alert>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
       
        <template v-else>
            <PowerApp  :app="app" :version="version" :entrypoint="entrypoint" :dist="dist" :noRouter="false" :key="version"/>
        </template>
    </div>
</template>

<script>
import PowerApp from './PowerApp';

export default {
    name: 'Playground',
    components: {
        PowerApp
    },

    data: function() {
        return {
            port: 11400,
            app: {
                app_version: null,
                uuid: 'test',
                name: 'playground',
                engine: null,
            },

            entrypoint: 'index',
            dist: null,
            version: 1,
            connected: false
        }
    },

    methods: {
        connect() {
            const sock = new WebSocket(`ws://localhost:${this.port}`);

            sock.addEventListener("close", () => {
                this.connected = false
                this.dist = null
                this.app.app_version = null
                this.app.engine = null
            })

            sock.addEventListener("open", () => {
                this.connected = true
            })

            sock.addEventListener('message', (event) => {
                const data = JSON.parse(event.data)
                const { sdkVersion, engine } = data || {}

                switch (data.action) {
                    case 'update': 
                        if (sdkVersion) {
                            this.app.app_version = sdkVersion
                            this.app.engine = engine
                        }
                        
                        this.dist = Object.assign({}, this.dist || {}, data.dist);

                        this.version++;

                        return;
                    
                    case 'delete': {
                        console.log("event", data)
                        data.files.forEach(file => {
                            delete this.dist[file]
                        })

                        this.version++;
                    }
                }
            })
        }
    },

    updated() {
        console.log("updated")
    },

    created() {
        setInterval(() => {
            if (!this.connected) {
                this.connect()
            }
        }, 3000)
    },

    mounted() {
        this.connect()
    }
}
</script>